// Component to sync user preferences (theme, language) from database on app startup
import { useEffect, useRef } from "react";
import { useTheme } from "next-themes";
import { useUserPreferences } from "@/hooks/useUserPreferences";

export function PreferencesSync() {
  const { setTheme } = useTheme();
  const { data: preferences } = useUserPreferences();
  const hasSynced = useRef(false);

  // Sync theme from database ONCE when preferences first load
  // This prevents fighting with manual theme toggles on Landing/Auth pages
  useEffect(() => {
    if (preferences?.theme && !hasSynced.current) {
      hasSynced.current = true;
      setTheme(preferences.theme);
    }
  }, [preferences?.theme, setTheme]);

  return null; // This component doesn't render anything
}
